var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.list,
            stripe: "",
            "highlight-current-row": "",
            "tooltip-effect": "dark",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "taskDescription",
              label: _vm.$t("sfe.taskassignment.table.taskDescription"),
              "min-width": "200",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "allocatedType",
              label: _vm.$t("sfe.taskassignment.table.allocatedType"),
              "min-width": "150",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "deadlineTime",
              label: _vm.$t("sfe.taskassignment.table.deadlineTimeFormatted"),
              "min-width": "150",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "rsmEmpNo",
              label: _vm.$t("sfe.taskassignment.table.rsmEmpNo"),
              "min-width": "150",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "rsmEmpName",
              label: _vm.$t("sfe.taskassignment.table.rsmEmpName"),
              "min-width": "120",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "asmEmpNo",
              label: _vm.$t("sfe.taskassignment.table.asmEmpNo"),
              "min-width": "180",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "asmEmpName",
              label: _vm.$t("sfe.taskassignment.table.asmEmpName"),
              "min-width": "180",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "srEmpNo",
              label: _vm.$t("sfe.taskassignment.table.srEmpNo"),
              "min-width": "180",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "srEmpName",
              label: _vm.$t("sfe.taskassignment.table.srEmpName"),
              "min-width": "120",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "rtlRtmCategory",
              label: _vm.$t("sfe.taskassignment.table.rtlRtmCategory"),
              "min-width": "180",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "retailerType",
              label: _vm.$t("sfe.taskassignment.table.retailerType"),
              "min-width": "180",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "spSapId",
              label: _vm.$t("sfe.taskassignment.table.spSapId"),
              "min-width": "180",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "spFullName",
              label: _vm.$t("sfe.taskassignment.table.spFullName"),
              "min-width": "180",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "rtlRegion",
              label: _vm.$t("sfe.taskassignment.table.rtlRegion"),
              "min-width": "180",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "rtlCity",
              label: _vm.$t("sfe.taskassignment.table.rtlCity"),
              "min-width": "180",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "rtlSapId",
              label: _vm.$t("sfe.taskassignment.table.rtlSapId"),
              "min-width": "180",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "rtlFullName",
              label: _vm.$t("sfe.taskassignment.table.rtlFullName"),
              "min-width": "180",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "remark",
              label: _vm.$t("sfe.taskassignment.table.remark"),
              "min-width": "180",
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "errorMsg",
              label: _vm.$t("common.errorInfo"),
              "min-width": "180",
              fixed: "right",
              align: "center",
              "show-overflow-tooltip": "",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total>0",
          },
        ],
        attrs: { total: _vm.total, page: _vm.currPage, limit: _vm.limit },
        on: {
          "update:page": function ($event) {
            _vm.currPage = $event
          },
          "update:limit": function ($event) {
            _vm.limit = $event
          },
          pagination: _vm.fetchData,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }